module.exports = __webpack_public_path__ + "img/5-2.e6d42869.png";